module.exports = __webpack_public_path__ + "img/outline-more_vert-24px.a87ee174.svg";